import type { ContractRead } from "../../contract-management/services/contractTypes";
import type { AddressRequest, CustomerRead } from "../../customer-management/services/customerTypes";

export const siteTagTypes: SiteTagType[] = ["SiteList"];
export type SiteTagType = "SiteList";

export type SitesListApiResponse = /** status 200  */ PaginatedSiteListRead;
export type SitesListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** A search term. */
  search?: string;
  /** Which field to use when ordering the results. */
  sort?: string;
  include?: [];
};
export type SitesCreateApiResponse = /** status 201  */ SiteCreateRead;
export type SitesCreateApiArg = {
  createRequest: SiteCreateRequestWrite;
};
export type SitesRetrieveApiResponse = /** status 200  */ SiteRead;
export type SitesRetrieveApiArg = {
  /** A unique integer value identifying this site. */
  id: number;
  include?: string[];
};
export type SitesUpdateApiResponse = /** status 200  */ SiteUpdateRead;
export type SitesUpdateApiArg = {
  /** A unique integer value identifying this site. */
  id: number;
  updateRequest: SiteUpdateRequest;
};
export type SitesPartialUpdateApiResponse = /** status 200  */ SiteUpdateRead;
export type SitesPartialUpdateApiArg = {
  /** A unique integer value identifying this site. */
  id: number;
  patchedSiteUpdateRequest: PatchedSiteUpdateRequest;
};
export type SitesDestroyApiResponse = unknown;
export type SitesDestroyApiArg = {
  /** A unique integer value identifying this site. */
  id: number;
};

export type Address = {
  address_name: string;
  address_line_1: string;
  address_line_2?: string | null;
  post_code: string;
  city: string;
  country: string;
};
export type AddressRead = {
  id: number;
  created_at: string;
  updated_at: string;
  address_name: string;
  address_line_1: string;
  address_line_2?: string | null;
  post_code: string;
  city: string;
  country: string;
};
export type Site = {
  address: Address;
  name: string;
  customer: CustomerRead;
  contracts: ContractRead[];
  contract?: ContractRead; // write-only
  email?: string;
  system_size?: number;
  license?: number;
  start_date?: string;
};

export type SiteRead = {
  id: number;
  address: AddressRead;
  created_at: string;
  updated_at: string;
  meter_count?: number;
  name: string;
  customer: any;
  contracts: ContractRead[];
  email?: string;
  system_size?: number;
  license?: number;
  start_date?: string;
};

export type PaginatedSiteList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: Site[];
};
export type PaginatedSiteListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: SiteRead[];
};
export type CreateAddress = {
  address_name: string;
  address_line_1: string;
  address_line_2?: string | null;
  post_code: string;
  city: string;
  country: string;
};
export type CreateAddressRead = {
  created_at: string;
  updated_at: string;
  address_name: string;
  address_line_1: string;
  address_line_2?: string | null;
  post_code: string;
  city: string;
  country: string;
};

export type SiteCreate = {
  address: CreateAddress;
  customer: any;
  name: string;
  email?: string;
  system_size?: number;
  license?: number;
  start_date?: string;
};
export type SiteCreateRead = {
  id: number;
  address: CreateAddressRead;
  customer: any;
  created_at: string;
  updated_at: string;
  name: string;
  email?: string;
  system_size?: number;
  license?: number;
  start_date?: string;
};

export type CreateAddressRequest = {
  address_name: string;
  address_line_1: string;
  address_line_2?: string | null;
  post_code: string;
  city: string;
  country: string;
};

export type SiteCreateRequest = {
  address: CreateAddressRequest;
  customer: any;
  name: string;
  email?: string;
  system_size?: number;
  license?: number;
  start_date?: string;
};
export type SiteCreateRequestWrite = {
  address: CreateAddressRequest;
  contract: any;
  customer: any;
  name: string;
  email?: string;
  system_size?: number;
  license?: number;
  start_date?: string;
};

export type SiteUpdate = {
  address?: Address;
  name: string;
  customer: any;
  contract: any;
  email?: string;
  system_size?: number;
  license?: number;
  start_date?: string;
};
export type SiteUpdateRead = {
  id: number;
  address?: AddressRead;
  created_at: string;
  updated_at: string;
  name: string;
  customer: any;
  contract: any;
  email?: string;
  system_size?: number;
  license?: number;
  start_date?: string;
};

export type SiteUpdateRequest = {
  address?: AddressRequest;
  name: string;
  customer: any;
  contract: any;
  email?: string;
  system_size?: number;
  license?: number;
  start_date?: string;
};

export type PatchedSiteUpdateRequest = {
  address?: AddressRequest;
  name?: string;
  customer?: number;
  contract?: number;
  email?: string;
  system_size?: number;
  license?: number;
  start_date?: string;
};
